import * as React from 'react';

/**
 * Props type for JRCGrid
 * @member children: enclosed React component
 * @member cols : number of cols  "1" | "2" | "3"
 */
export interface JRCGridProps {
    children: React.ReactNode;
    cols: '1' | '2' | '3';
}

export const JRCGrid = (props: JRCGridProps) => (
    <div className={`r-grid page-${props.cols}-cols`}>{props.children}</div>
);
